// extracted by mini-css-extract-plugin
export default {"username":"PostSecondaryHeadline_username__NyGCM","userInfo":"PostSecondaryHeadline_userInfo__WNVrL"};